module.exports = __webpack_public_path__ + "static/55-Google-13a70196658c6f9709c55004920a0167.png";